export default __webpack_public_path__ + "static/media/logo GOB + Agenda 2030-B-01.937e12b0.png";